import { watch } from 'vue';

export const useOnFirstInputChangeCB = (ref, cb) => {
  const stop = watch(ref, (_, prev) => {
    if (prev === '') cb?.();
  });

  return stop;
};
